import type { BaseItemSchema } from "@memorang/types";
import Box from "@memorang/ui/components/Box";
import SessionItemShell from "@memorang/ui/components/StudySession/SessionItemShell";
import { useDevice } from "@memorang/ui/useDevice";
import { resolveItemTypeContainer } from "../helpers/item-type-registry";
import { isStudySessionSplitLayout } from "../helpers/split-layout";
import { useAilaStore } from "../hooks/useAilaStore";
import useSessionStore from "../hooks/useSessionStore";

interface Props {
	item: BaseItemSchema;
}

const ItemTypeContainer = ({ item }: Props) => {
	const { isMobile } = useDevice();
	const isSummativeTest = useSessionStore((s) => s.isSummativeTest);

	const isAilaDrawerVisible = useAilaStore((s) => s.showDrawer);

	const ItemTypeComponent = resolveItemTypeContainer(item);
	if (!ItemTypeComponent) {
		return null;
	}

	const isSplitLayout = isStudySessionSplitLayout(item, isMobile);

	const itemKey =
		item.id ?? item.versionId ?? `${item.type}-${item.metadata?.type}`;

	return (
		<SessionItemShell
			key={itemKey}
			isSplitLayout={Boolean(isSplitLayout)}
			sessionType={isSummativeTest ? "summative" : "formative"}
		>
			<Box
				flex={isSplitLayout ? 1 : undefined}
				paddingHorizontal={isAilaDrawerVisible ? 16 : 0}
			>
				<ItemTypeComponent
					key={itemKey}
					item={item}
					isSplitLayout={isSplitLayout}
					isSummativeTest={isSummativeTest}
				/>
			</Box>
		</SessionItemShell>
	);
};

export default ItemTypeContainer;
